export default __webpack_public_path__ + "static/media/DSC_0557.b1cb94b8.jpg";